module.exports = __webpack_public_path__ + "static/media/radioButton.ad98d4fb.svg";